<template>
  <div>
    <el-skeleton class="width100" :loading="true" animated :throttle="500">
      <template slot="template">
        <div class="backwhite width100 margin-auto border-rd3">
          <div class="Retrieveform pad-top20 pad-bot10">
            <p
              class="width96 margin-auto Patent-abstract pad-left10 dimensional"
            >
              成果基本情况
            </p>
            <div class="width96 margin-auto pad-top20 pad-bot20">
              <table class="width100 text-ellipsis">
                <tr>
                  <td class="tdtit">成果名称</td>
                  <td class="tdcont">{{ title }}</td>
                  <td class="tdtit">量产或产业化状态</td>
                  <td class="tdcont">
                    {{
                      pro == "0"
                        ? "未量产或未实现产业化"
                        : "已产量或已实现产业化"
                    }}
                  </td>
                </tr>
              </table>
              <table class="width100 text-ellipsis">
                <tr>
                  <td
                    class="tdtit"
                    style="border-top: none; border-bottom: none"
                  >
                    成果自估值
                  </td>
                  <td
                    class="tdcont"
                    style="border-top: none; border-bottom: none"
                  >
                    {{ amount }}万元
                  </td>
                  <td v-if="companyentid != ent_id" style="border: none"></td>
                  <td v-if="companyentid != ent_id" style="border: none"></td>
                  <td
                    v-if="companyentid == ent_id"
                    class="tdtit"
                    style="border-top: none; border-bottom: none"
                  >
                    第三方估值
                  </td>
                  <td
                    class="tdcont"
                    style="border-top: none; border-bottom: none"
                    v-if="valuation == 0 && companyentid == ent_id"
                  >
                    未估值<span
                      class="bluecolor pad-left10 cursorpointer"
                      @click="estimate()"
                      >立即委托权威机构估值</span
                    >
                  </td>
                  <td
                    class="tdcont"
                    style="
                      color: #52c5cb;
                      border-top: none;
                      border-bottom: none;
                    "
                    v-if="valuation == 1 && companyentid == ent_id"
                  >
                    已委托权威机构估值
                  </td>
                  <td
                    class="tdcont"
                    style="
                      color: #52c5cb;
                      border-top: none;
                      border-bottom: none;
                    "
                    v-if="valuation == 2 && companyentid == ent_id"
                  >
                    已估值
                  </td>
                </tr>
              </table>
              <table class="width100 margin-bot10">
                <tr class="margin-top10">
                  <td class="tdtit">技术分类</td>
                  <td class="tdconts">{{ ipc }}</td>
                </tr>
              </table>
              <table class="width100" v-if="companyentid == ent_id">
                <tr>
                  <td class="tdtit">成果转化与交易</td>
                  <td class="tdcontss" v-if="sell == 0">
                    <p><i class="icon-icon iconfont"></i>未委托平台出售</p>
                    <p>
                      委托平台出售成果，可快速实现研发成果变现或融资，可以点击
                      <span
                        class="bluecolor cursorpointer"
                        @click="Consignmentsale()"
                        >委托出售</span
                      >
                      快速发起成果委托。
                    </p>
                    <p v-if="valuation == 0">
                      <i class="icon-icon iconfont"></i>未委托权威机构估值
                    </p>
                    <p v-if="valuation == 0">
                      委托第三方权威机构进行成果估值，可以成果融资或变现过程中取得更高的可信度，点击<span
                        class="bluecolor cursorpointer"
                        @click="estimate()"
                      >
                        委托估值 </span
                      >可以一键委托第三方机构估值。
                    </p>
                    <p
                      v-if="valuation == 1"
                      @mouseenter="filemouseenters()"
                      @mouseleave="filemouseleaves()"
                      class="bluecolor cursorpointer"
                    >
                      <i class="icon-icon iconfont"></i
                      ><span v-if="alreadys">已委托权威机构估值</span>
                      <span v-if="Cancels" @click="Cancelwts()">取消委托</span>
                    </p>
                    <p v-if="valuation == 1">
                      委托第三方权威机构进行成果估值，可以成果融资或变现过程中取得更高的可信度
                    </p>
                    <p v-if="valuation == 2" class="bluecolor">
                      <i class="icon-icon iconfont"></i>已估值
                    </p>
                  </td>

                  <td class="tdcontss" v-if="sell == 1">
                    <p
                      class="bluecolor cursorpointer"
                      @mouseenter="filemouseenter()"
                      @mouseleave="filemouseleave()"
                    >
                      <i class="icon-icon iconfont"></i
                      ><span v-if="already">已经委托平台出售</span
                      ><span v-if="Cancel" @click="Cancelwt()">取消委托</span>
                    </p>
                    <p>委托平台出售成果，可快速实现研发成果变现或融资</p>
                    <p v-if="valuation == 0">
                      <i class="icon-icon iconfont"></i>未委托权威机构估值
                    </p>
                    <p v-if="valuation == 0">
                      委托第三方权威机构进行成果估值，可以成果融资或变现过程中取得更高的可信度，点击<span
                        class="bluecolor cursorpointer"
                        @click="estimate()"
                      >
                        委托估值 </span
                      >可以一键委托第三方机构估值。
                    </p>
                    <p
                      v-if="valuation == 1"
                      @mouseenter="filemouseenters()"
                      @mouseleave="filemouseleaves()"
                      class="bluecolor cursorpointer"
                    >
                      <i class="icon-icon iconfont"></i
                      ><span v-if="alreadys">已委托权威机构估值</span>
                      <span v-if="Cancels" @click="Cancelwts()">取消委托</span>
                    </p>
                    <p v-if="valuation == 1">
                      委托第三方权威机构进行成果估值，可以成果融资或变现过程中取得更高的可信度
                    </p>
                    <p v-if="valuation == 2" class="bluecolor">
                      <i class="icon-icon iconfont"></i>已估值
                    </p>
                  </td>

                  <td class="tdcontss" v-if="sell == 2">
                    <p class="bluecolor">
                      <i class="icon-icon iconfont"></i>已出售
                    </p>
                    <p>委托平台出售成果，可快速实现研发成果变现或融资</p>
                    <p v-if="valuation == 0">
                      <i class="icon-icon iconfont"></i>未委托权威机构估值
                    </p>
                    <p v-if="valuation == 0">
                      委托第三方权威机构进行成果估值，可以成果融资或变现过程中取得更高的可信度，点击<span
                        class="bluecolor cursorpointer"
                        @click="estimate()"
                      >
                        委托估值 </span
                      >可以一键委托第三方机构估值。
                    </p>
                    <p
                      v-if="valuation == 1"
                      @mouseenter="filemouseenters()"
                      @mouseleave="filemouseleaves()"
                      class="bluecolor cursorpointer"
                    >
                      <i class="icon-icon iconfont"></i
                      ><span v-if="alreadys">已委托权威机构估值</span>
                      <span v-if="Cancels" @click="Cancelwts()">取消委托</span>
                    </p>
                    <p v-if="valuation == 1">
                      委托第三方权威机构进行成果估值，可以成果融资或变现过程中取得更高的可信度
                    </p>
                    <p v-if="valuation == 2" class="bluecolor">
                      <i class="icon-icon iconfont"></i>已估值
                    </p>
                  </td>
                </tr>
              </table>
              <table class="width100 margin-top10">
                <tr class="margin-top10">
                  <td class="tdtit">技术成熟度说明</td>
                  <td class="tdconts" v-html="maturity"></td>
                </tr>
                <tr class="margin-top10">
                  <td class="tdtit">成果说明</td>
                  <td class="tdconts" v-html="remark"></td>
                </tr>
              </table>
            </div>
          </div>
        </div>

        <div class="backwhite width100 margin-auto border-rd3 pad-bot20">
          <div class="achieBox pad-top20">
            <p
              class="width96 margin-auto Patent-abstract pad-left10 dimensional"
            >
              附加成果
            </p>
            <el-tabs
              v-model="activeName"
              type="border-card"
              class="width96 margin-auto margin-top20 border-rd3"
            >
              <el-tab-pane label="专利授权" name="first" class="main-items">
                <div v-if="havepatent && companyentid == ent_id">
                  <div
                    class="itemcont"
                    v-for="(item, index) in patent"
                    :key="index"
                  >
                    <div
                      class="flex cursorpointer"
                      @click="patentdetaliy(index)"
                    >
                      <div class="itembor"></div>
                      {{ item.patent != null ? item.patent.title : null }}
                    </div>
                    <p class="cursorpointer bluecolor" @click="removep(index)">
                      移出成果
                    </p>
                  </div>
                </div>

                <div
                  class="nullachi"
                  v-if="nullpatent && companyentid == ent_id"
                >
                  <p>当前项目暂无附加成果</p>
                  <p>点击右上角附加成果按钮进行添加</p>
                </div>
                <div class="nullachi" v-if="companyentid != ent_id">
                  <p>
                    当前成果正在出售，请发起成果采购需求，成果所有人会与您对接相关事宜。
                  </p>
                </div>
              </el-tab-pane>
              <el-tab-pane label="商标品牌" name="second" class="main-items">
                <div v-if="havetrademark && companyentid == ent_id">
                  <div
                    class="itemcont"
                    v-for="(item, index) in trademark"
                    :key="index"
                  >
                    <div class="flex width80" @click="trandmarkdetaliy(index)">
                      <div class="itembor"></div>
                      <p class="width30">
                        <span
                          >[第{{
                            item.trademark != null
                              ? item.trademark.InternationalClass
                              : null
                          }}类]：</span
                        >
                        {{
                          item.trademark != null
                            ? item.trademark.RegNumber
                            : null
                        }}
                      </p>
                      <p class="width30 textalign-center">
                        <span>商标名称：</span>
                        {{
                          item.trademark != null
                            ? item.trademark.TrademarkName
                            : null
                        }}
                      </p>
                      <p class="width30 textalign-right">
                        <span>申请人：</span>
                        {{
                          item.trademark != null
                            ? item.trademark.RegisterName
                            : null
                        }}
                      </p>
                    </div>

                    <p
                      class="cursorpointer bluecolor cursorpointer"
                      @click="removet(index)"
                    >
                      移出成果
                    </p>
                  </div>
                </div>

                <div
                  class="nullachi"
                  v-if="nulltrademark && companyentid == ent_id"
                >
                  <p>当前项目暂无附加成果</p>
                  <p>点击右上角附加成果按钮进行添加</p>
                </div>
                <div class="nullachi" v-if="companyentid != ent_id">
                  <p>
                    当前成果正在出售，请发起成果采购需求，成果所有人会与您对接相关事宜。
                  </p>
                </div>
              </el-tab-pane>
              <el-tab-pane label="原创认证" name="third" class="main-items">
                <div v-if="haveorigin && companyentid == ent_id">
                  <div
                    class="itemcont"
                    v-for="(item, index) in origin"
                    :key="index"
                  >
                    <div class="flex">
                      <div class="itembor"></div>
                      {{ item.origin != null ? item.origin.title : null }}
                    </div>
                    <p class="cursorpointer bluecolor" @click="removeo(index)">
                      移出成果
                    </p>
                  </div>
                </div>
                <div
                  class="nullachi"
                  v-if="nullorigin && companyentid == ent_id"
                >
                  <p>当前项目暂无附加成果</p>
                  <p>点击右上角附加成果按钮进行添加</p>
                </div>
                <div class="nullachi" v-if="companyentid != ent_id">
                  <p>
                    当前成果正在出售，请发起成果采购需求，成果所有人会与您对接相关事宜。
                  </p>
                </div>
              </el-tab-pane>
              <el-tab-pane label="研发项目" name="fourth" class="main-items">
                <div v-if="havescipro && companyentid == ent_id">
                  <div
                    class="itemcont"
                    v-for="(item, index) in scipro"
                    :key="index"
                  >
                    <div class="flex" @click="sciprodetaliy(index)">
                      <div class="itembor"></div>
                      {{ item.dev != null ? item.dev.title : null }}
                    </div>
                    <p
                      class="cursorpointer bluecolor"
                      @click="removesci(index)"
                    >
                      移出成果
                    </p>
                  </div>
                </div>
                <div
                  class="nullachi"
                  v-if="nullscipro && companyentid == ent_id"
                >
                  <p>当前项目暂无研发项目</p>
                  <p>点击右上角附加成果按钮进行添加</p>
                </div>
                <div class="nullachi" v-if="companyentid != ent_id">
                  <p>
                    当前成果正在出售，请发起成果采购需求，成果所有人会与您对接相关事宜。
                  </p>
                </div>
              </el-tab-pane>
              <el-tab-pane label="研发产品" name="fifth" class="main-items">
                <div v-if="havecp && companyentid == ent_id">
                  <div
                    class="itemcont"
                    v-for="(item, index) in product"
                    :key="index"
                  >
                    <div class="flex" @click="productdetaliy(index)">
                      <div class="itembor"></div>
                      {{ item.product != null ? item.product.title : null }}
                    </div>
                    <p class="cursorpointer bluecolor" @click="removecp(index)">
                      移出成果
                    </p>
                  </div>
                </div>
                <div class="nullachi" v-if="nullcp && companyentid == ent_id">
                  <p>当前项目暂无研发产品</p>
                  <p>点击右上角附加成果按钮进行添加</p>
                </div>
                <div class="nullachi" v-if="companyentid != ent_id">
                  <p>
                    当前成果正在出售，请发起成果采购需求，成果所有人会与您对接相关事宜。
                  </p>
                </div>
              </el-tab-pane>
            </el-tabs>
            <div class="addachie cursorpointer" v-if="companyentid == ent_id">
              <span class="attention f14" @click="dialogtrusteeship = true"
                >附加成果</span
              >
            </div>
          </div>
          <div class="but-box textalign-right">
            <el-button
              type="primary"
              class="cursorpointer"
              @click="Savechanges()"
            >
              保 存
            </el-button>
          </div>
        </div>
      </template>
    </el-skeleton>

    <el-dialog
      width="60%"
      title=""
      :visible.sync="dialogtrusteeship"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
    >
      <div class="f16 width98 textalign-left dimensional">附加成果</div>
      <div class="dialogcont">
        <el-tabs
          v-model="activeName"
          type="card"
          tab-position="left"
          :stretch="true"
          class="tabscard"
        >
          <el-tab-pane label="专利授权" name="first">
            <el-input
              placeholder="关键字"
              v-model="input1"
              class="input-with-select"
              @input="oninput()"
            >
              <el-button slot="append" icon="el-icon-search"></el-button>
            </el-input>
            <div class="overflow">
              <div class="dialogitem">
                <el-checkbox-group
                  v-model="checkList"
                  v-for="(item, index) in page"
                  :key="index"
                  @change="PersonnelChange"
                >
                  <el-checkbox
                    class="margin-top10 width100 checkboxgroup"
                    :label="index"
                  >
                    <div class="">
                      <p class="width70">{{ item.title }}</p>
                      <p
                        class="dialogel cursorpointer bluecolor"
                        @click="addpatant(index)"
                      >
                        加入成果
                      </p>
                    </div>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
              <p
                class="textalign-right pad-top20"
                style="border-top: 1px solid #f0f0f0"
              >
                <el-button @click="trusteeshippant()" v-if="Project"
                  >更 多</el-button
                >
                <el-button type="primary" @click="addpatantall()"
                  >批量添加</el-button
                >
              </p>
            </div>
          </el-tab-pane>
          <el-tab-pane label="商标品牌" name="second">
            <el-input
              placeholder="关键字"
              v-model="input2"
              class="input-with-select"
              @input="oninputs()"
            >
              <el-button slot="append" icon="el-icon-search"></el-button>
            </el-input>
            <div class="overflow">
              <div class="dialogitem">
                <el-checkbox-group
                  v-model="checkLists"
                  v-for="(item, index) in page1"
                  :key="index"
                  @change="PersonnelChanges"
                >
                  <el-checkbox
                    class="margin-top10 width100 checkboxgroup"
                    :label="index"
                  >
                    <div class="">
                      <p class="width70">
                        {{ item.TrademarkName }}{{ [parseInt(item.RegNumber)]
                        }}{{ item.RegisterName }}
                      </p>
                      <p
                        class="dialogel cursorpointer bluecolor"
                        @click="addtrand(index)"
                      >
                        加入成果
                      </p>
                    </div>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
              <p
                class="textalign-right pad-top20"
                style="border-top: 1px solid #f0f0f0"
              >
                <el-button @click="trusteeshiptrand()" v-if="Projects"
                  >更 多</el-button
                >
                <el-button type="primary" @click="addtrandall()"
                  >批量添加</el-button
                >
              </p>
            </div></el-tab-pane
          >
          <el-tab-pane label="原创认证" name="third">
            <el-input
              placeholder="关键字"
              v-model="input3"
              class="input-with-select"
              @input="oninputss()"
            >
              <el-button slot="append" icon="el-icon-search"></el-button>
            </el-input>
            <div class="overflow">
              <div class="dialogitem">
                <el-checkbox-group
                  v-model="checkListss"
                  v-for="(item, index) in page2"
                  :key="index"
                  @change="PersonnelChangess"
                >
                  <el-checkbox
                    class="margin-top10 width100 checkboxgroup"
                    :label="index"
                  >
                    <div class="">
                      <p class="width70">
                        {{ item.title }}
                      </p>
                      <p
                        class="dialogel cursorpointer bluecolor"
                        @click="addcert(index)"
                      >
                        加入成果
                      </p>
                    </div>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
              <p
                class="textalign-right pad-top20"
                style="border-top: 1px solid #f0f0f0"
              >
                <el-button @click="trusteeshipcert()" v-if="Projectss"
                  >更 多</el-button
                >
                <el-button type="primary" @click="addcertall()"
                  >批量添加</el-button
                >
              </p>
            </div>
          </el-tab-pane>
          <el-tab-pane label="研发项目" name="fourth">
            <el-input
              placeholder="关键字"
              v-model="input4"
              class="input-with-select"
              @input="oninputsss()"
            >
              <el-button slot="append" icon="el-icon-search"></el-button>
            </el-input>
            <div class="overflow">
              <div class="dialogitem">
                <el-checkbox-group
                  v-model="checkListsss"
                  v-for="(item, index) in page3"
                  :key="index"
                  @change="PersonnelChangesss"
                >
                  <el-checkbox
                    class="margin-top10 width100 checkboxgroup"
                    :label="index"
                  >
                    <div class="">
                      <p class="width70">
                        {{ item.title }}
                      </p>
                      <p
                        class="dialogel cursorpointer bluecolor"
                        @click="addsci(index)"
                      >
                        加入成果
                      </p>
                    </div>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
              <p
                class="textalign-right pad-top20"
                style="border-top: 1px solid #f0f0f0"
              >
                <el-button @click="trusteeshipsci()" v-if="Projectsss"
                  >更 多</el-button
                >
                <el-button type="primary" @click="addscitall()"
                  >批量添加</el-button
                >
              </p>
            </div>
          </el-tab-pane>
          <el-tab-pane label="研发产品" name="fifth">
            <el-input
              placeholder="关键字"
              v-model="input4"
              class="input-with-select"
              @input="oninputssss()"
            >
              <el-button slot="append" icon="el-icon-search"></el-button>
            </el-input>
            <div class="overflow">
              <div class="dialogitem">
                <el-checkbox-group
                  v-model="checkListssss"
                  v-for="(item, index) in page4"
                  :key="index"
                  @change="PersonnelChangessss"
                >
                  <el-checkbox
                    class="margin-top10 width100 checkboxgroup"
                    :label="index"
                  >
                    <div class="">
                      <p class="width70">
                        {{ item.title }}
                      </p>
                      <p
                        class="dialogel cursorpointer bluecolor"
                        @click="addcp(index)"
                      >
                        加入成果
                      </p>
                    </div>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
              <p
                class="textalign-right pad-top20"
                style="border-top: 1px solid #f0f0f0"
              >
                <el-button @click="trusteeshipcp()" v-if="Projectssss"
                  >更 多</el-button
                >
                <el-button type="primary" @click="addcpall()"
                  >批量添加</el-button
                >
              </p>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="dialogVisiintroduction"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorboxs"
    >
      <p class="textalign-left f18">成果估值委托</p>
      <div class="textalign-left margin-top30 pad-bot20">
        <p class="f16" style="color: #3d3d3d">为什么委托第三方进行成果估值？</p>
        <p class="pad-top10">
          第三方权威估值机构，拥有更多产业成果转化经验，能根据市场动态评估出
          更为精准的成果价值，在后续交易中为您的成果价值提供有力的产业证明。
        </p>
        <div>
          <el-checkbox
            v-model="guzgiremark"
            :true-label="1"
            :false-label="0"
            class="margin-top20"
            >确认委托第三方提供成果估值服务。</el-checkbox
          >
        </div>
      </div>
      <div class="but-box textalign-right">
        <el-button @click="dialogVisiintroduction = false">取 消</el-button>
        <el-button class="f14" type="primary" @click="guzhichange()">
          保 存
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="dialogVisisell"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorboxs"
    >
      <p class="textalign-left f18">成果出售委托</p>
      <div class="textalign-left margin-top30 pad-bot20">
        <p class="f16" style="color: #3d3d3d">为什么委托平台出售成果？</p>
        <p class="pad-top10">
          委托平台出售成果，可以快速利用成果变现、融资，实现成果产业转化，实现更
          大的社会和经济效益，推动企业更好的发展。
        </p>
        <div>
          <p class="margin-top20">出售预期价格（万元）</p>
          <el-input
            placeholder="请输入您的成果预期出售价格，单位为万元"
            v-model="sell_price"
            class="inputDeep margin-top10"
          >
          </el-input>
          <p class="margin-top20">成果转让方式说明</p>
          <el-input
            placeholder="请输入成果转让方式，如技术入股，整体转让等"
            v-model="sell_way"
            type="textarea"
            :autosize="autosize"
            class="inputDeep margin-top10"
            maxlength="500"
            rows="5"
            cols="20"
          >
          </el-input>
          <el-checkbox
            v-model="sell_sure"
            :true-label="1"
            :false-label="0"
            class="margin-top20"
            >确认委托平台出售该成果并确认该行为不侵犯第三方权益。</el-checkbox
          >
        </div>
      </div>
      <div class="but-box textalign-right">
        <el-button @click="dialogVisisell = false">取 消</el-button>
        <el-button class="f14" type="primary" @click="sellchange()">
          保 存
        </el-button>
      </div>
    </el-dialog>
    <!-- 专利详情 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisiblepantent"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="50%"
    >
      <p class="textalign-left f16">专利详情</p>
      <div class="textalign-left margin-top10">
        <pantent></pantent>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblepantent = false" class="errorbutton">
          关 闭
        </span>
      </span>
    </el-dialog>
    <!-- 商标详情 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisibletrandmark"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="50%"
    >
      <p class="textalign-left f16">商标详情</p>
      <div class="textalign-left margin-top10">
        <trandmark></trandmark>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisibletrandmark = false" class="errorbutton">
          关 闭
        </span>
      </span>
    </el-dialog>

    <!-- 研发项目详情 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisiblescipro"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="50%"
    >
      <p class="textalign-left f16">研发项目详情</p>
      <div class="textalign-left margin-top10">
        <scipro></scipro>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblescipro = false" class="errorbutton">
          关 闭
        </span>
      </span>
    </el-dialog>
    <!-- 研发产品详情 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisibleproduct"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="50%"
    >
      <p class="textalign-left f16">研发产品详情</p>
      <div class="textalign-left margin-top10">
        <product></product>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisibleproduct = false" class="errorbutton">
          关 闭
        </span>
      </span>
    </el-dialog>
  </div>
</template>
      
      <script>
import {
  entachievementsdetail,
  entachievementsadditem,
  entachievementsremoveitem,
  researchprojects,
  entproductindex,
} from "@/api/Center/Center.api";
import {
  patenttrusteeshipentpatent,
  Obtaintrademark,
  makerindex,
} from "@/api/patent/patent.api";
import { entachievementsentrust } from "@/api/business/business.api";
import pantent from "./patentdetaliy.vue";
import trandmark from "./trandmarkdetaliy.vue";
import scipro from "./sciprodetaliy.vue";
import product from "./productdetaliy.vue";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      dialogVisiblepantent: false,
      dialogVisibletrandmark: false,
      dialogVisiblescipro: false,
      dialogVisibleproduct: false,
      errormessage: "",
      dialogVisiblenull: false,
      dialogtrusteeship: false,
      dialogVisiintroduction: false,
      dialogVisisell: false,
      autosize: {
        minRows: 3,
        maxRows: 1000,
      },
      guzhiid: "",
      guzgiremark: "",
      sell_price: "",
      sell_way: "",
      sell_sure: "",
      activeName: "",
      id: "",
      patent: "",
      trademark: "",
      origin: "",
      scipro: "",
      havepatent: false,
      nullpatent: false,
      havetrademark: false,
      nulltrademark: false,
      haveorigin: false,
      nullorigin: false,
      havescipro: false,
      nullscipro: false,
      havecp: false,
      nullcp: false,
      thisNum: 1,
      page: "",
      Project: false,
      input1: "",
      thisNums: 1,
      page1: "",
      Projects: false,
      input2: "",
      thisNumss: 1,
      page2: "",
      Projectss: false,
      input3: "",
      thisNumsss: 1,
      page3: "",
      Projectsss: false,
      input4: "",
      thisNumssss: 1,
      page4: "",
      Projectssss: false,
      input5: "",
      title: "",
      pro: "",
      amount: "",
      remark: "",
      sell: "",
      valuation: "",
      maturity: "",
      checkList: [],
      PersonnelChangeid: [],
      checkLists: [],
      PersonnelChangeids: [],
      checkListss: [],
      PersonnelChangeidss: [],
      checkListsss: [],
      PersonnelChangeidsss: [],
      checkListssss: [],
      PersonnelChangeidssss: [],
      val: [],
      vals: [],
      valss: [],
      valsss: [],
      valssss: [],
      ipc: "",
      companyentid: "",
      ent_id: "",
      already: true,
      Cancel: false,
      alreadys: true,
      Cancels: false,
    };
  },
  components: { pantent, trandmark, scipro, product },
  methods: {
    // 专利授权详情
    patentdetaliy(index) {
      BUS.$emit("patentdetaliyid", this.patent[index].patent_id);
      window.sessionStorage.setItem(
        "patentdetaliyid",
        this.patent[index].patent_id
      );
      this.dialogVisiblepantent = true;
    },
    // 商标授权详情
    trandmarkdetaliy(index) {
      this.dialogVisibletrandmark = true;
      BUS.$emit("trademarkdetaliyid", this.trademark[index].trademark_id);
      window.sessionStorage.setItem(
        "trademarkdetaliyid",
        this.trademark[index].trademark_id
      );
    },

    // 研发项目详情
    sciprodetaliy(index) {
      this.dialogVisiblescipro = true;
      BUS.$emit("sciprodetaliyid", this.scipro[index].dev_id);
      window.sessionStorage.setItem(
        "sciprodetaliyid",
        this.scipro[index].dev_id
      );
    },
    // 研发项目详情
    productdetaliy(index) {
      this.dialogVisibleproduct = true;
      BUS.$emit("productdetaliyid", this.product[index].product_id);
      window.sessionStorage.setItem(
        "productdetaliyid",
        this.product[index].product_id
      );
    },

    // 已委托出售移入移出
    filemouseenter() {
      this.already = false;
      this.Cancel = true;
    },
    filemouseleave() {
      this.already = true;
      this.Cancel = false;
    },
    // 取消委托出售
    Cancelwt() {
      this.$confirm("此操作将取消出售此成果, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          entachievementsentrust({ id: this.id, sell: 0 }).then((res) => {
            if (res.data.code == 200) {
              this.refresh();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 已委托估值移入移出
    filemouseenters() {
      this.alreadys = false;
      this.Cancels = true;
    },
    filemouseleaves() {
      this.alreadys = true;
      this.Cancels = false;
    },
    // 取消委托估值
    Cancelwts() {
      this.$confirm("此操作将取消此成果估值, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          entachievementsentrust({ id: this.id, valuation: 0 }).then((res) => {
            if (res.data.code == 200) {
              this.refresh();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 估值
    estimate() {
      this.dialogVisiintroduction = true;
      this.guzhiid = this.id;
    },
    guzhichange() {
      entachievementsentrust({
        id: this.guzhiid,
        valuation: this.guzgiremark,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "提交成功",
            type: "success",
          });
          this.dialogVisiintroduction = false;
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 委托出售
    Consignmentsale() {
      this.dialogVisisell = true;
    },
    sellchange() {
      entachievementsentrust({
        id: this.id,
        sell: this.sell_sure,
        sell_way: this.sell_way,
        sell_price: this.sell_price,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "提交成功",
            type: "success",
          });
          this.dialogVisisell = false;
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    PersonnelChange(val) {
      this.val = val;
    },
    addpatantall(index) {
      this.val.forEach((i) => {
        this.PersonnelChangeid.push(this.page[i].id);
      });
      entachievementsadditem({
        achievements_id: this.id,
        patent_id: this.PersonnelChangeid, //原创认证 专利 商标只能传一样
      }).then((res) => {
        if (res.data.code == 200) {
          window.sessionStorage.setItem("AchievementNamefujian", "first");
          this.refresh();
          this.dialogtrusteeship = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    PersonnelChanges(val) {
      this.vals = val;
    },
    addtrandall(index) {
      this.vals.forEach((i) => {
        this.PersonnelChangeids.push(this.page1[i].id);
      });
      entachievementsadditem({
        achievements_id: this.id,
        trademark_id: this.PersonnelChangeids, //原创认证 专利 商标只能传一样
      }).then((res) => {
        if (res.data.code == 200) {
          window.sessionStorage.setItem("AchievementNamefujian", "second");
          this.refresh();
          this.dialogtrusteeship = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    PersonnelChangess(val) {
      this.valss = val;
    },
    addcertall() {
      this.valss.forEach((i) => {
        this.PersonnelChangeidss.push(this.page2[i].id);
      });
      entachievementsadditem({
        achievements_id: this.id,
        origin_id: this.PersonnelChangeidss, //原创认证 专利 商标只能传一样
      }).then((res) => {
        if (res.data.code == 200) {
          window.sessionStorage.setItem("AchievementNamefujian", "third");
          this.refresh();
          this.dialogtrusteeship = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    PersonnelChangesss(val) {
      this.valsss = val;
    },
    addscitall() {
      this.valsss.forEach((i) => {
        this.PersonnelChangeidsss.push(this.page3[i].id);
      });
      entachievementsadditem({
        achievements_id: this.id,
        dev_id: this.PersonnelChangeidsss, //原创认证 专利 商标只能传一样
      }).then((res) => {
        if (res.data.code == 200) {
          window.sessionStorage.setItem("AchievementNamefujian", "fourth");
          this.refresh();
          this.dialogtrusteeship = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    PersonnelChangessss(val) {
      this.valssss = val;
    },
    addcpall() {
      this.valssss.forEach((i) => {
        this.PersonnelChangeidssss.push(this.page4[i].id);
      });
      entachievementsadditem({
        achievements_id: this.id,
        product_id: this.PersonnelChangeidssss, //原创认证 专利 商标只能传一样
      }).then((res) => {
        if (res.data.code == 200) {
          window.sessionStorage.setItem("AchievementNamefujian", "fifth");
          this.refresh();
          this.dialogtrusteeship = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 确定
    Savechanges() {
      BUS.$emit("resultsadd", "yes");
    },
    // 专利加入成果
    addpatant(index) {
      entachievementsadditem({
        achievements_id: this.id,
        patent_id: this.page[index].id, //原创认证 专利 商标只能传一样
      }).then((res) => {
        if (res.data.code == 200) {
          window.sessionStorage.setItem("AchievementNamefujian", "first");
          this.refresh();
          this.dialogtrusteeship = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    trusteeshippant() {
      const n = ++this.thisNum;
      // 获取出售中的专利
      patenttrusteeshipentpatent({ page: n }).then((res) => {
        if (res.data.code == 200) {
          if (res.data.data.data.length == 0) {
            this.Project = false;
            this.nullNum = true;
          } else {
            this.pages = res.data.data.data;
            this.pages.forEach((i) => {
              if (i.warnDate == null) {
                i.warnDate = "";
              }

              this.page.push(i);
            });
          }
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 全部专利模糊查询
    oninput() {
      if (this.input1 != "") {
        patenttrusteeshipentpatent({ _keywords: this.input1 }).then((res) => {
          if (res.data.code == 200) {
            this.page = res.data.data.data;
            this.page.forEach((i) => {
              if (i.warnDate == null) {
                i.warnDate = "";
              }
            });
            if (res.data.data.total > 5) {
              this.Project = true;
            } else {
              this.Project = false;
            }
          } else {
            this.$loading.hide(); // 隐藏loading
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        // 获取企业专利
        patenttrusteeshipentpatent({ page: this.thisNums }).then((res) => {
          if (res.data.code == 200) {
            this.page = res.data.data.data;
            this.page.forEach((i) => {
              if (i.warnDate == null) {
                i.warnDate = "";
              }
            });
            if (res.data.data.total > 5) {
              this.Project = true;
            } else {
              this.Project = false;
            }
          } else {
            this.$loading.hide(); // 隐藏loading
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },

    // 商标加入成果
    addtrand(index) {
      entachievementsadditem({
        achievements_id: this.id,
        trademark_id: this.page1[index].id, //原创认证 专利 商标只能传一样
      }).then((res) => {
        if (res.data.code == 200) {
          window.sessionStorage.setItem("AchievementNamefujian", "second");
          this.refresh();
          this.dialogtrusteeship = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    trusteeshiptrand() {
      const n = ++this.thisNums;
      // 获取更多的商标
      Obtaintrademark({ page: n }).then((res) => {
        if (res.data.code == 200) {
          if (res.data.data.data.length == 0) {
            this.Projects = false;
            this.nullNum = true;
          } else {
            this.pages = res.data.data.data;
            this.pages.forEach((i) => {
              this.page1.push(i);
            });
          }
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 全部商标模糊查询
    oninputs() {
      if (this.input2 != "") {
        Obtaintrademark({ _keywords: this.input2 }).then((res) => {
          if (res.data.code == 200) {
            this.page1 = res.data.data.data;
            if (res.data.data.total > 5) {
              this.Projects = true;
            } else {
              this.Projects = false;
            }
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
          this.$loading.hide(); // 隐藏loading
        });
      } else {
        // 获取商标
        Obtaintrademark({ page: this.thisNums }).then((res) => {
          if (res.data.code == 200) {
            this.page1 = res.data.data.data;
            if (res.data.data.total > 5) {
              this.Projects = true;
            } else {
              this.Projects = false;
            }
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
          this.$loading.hide(); // 隐藏loading
        });
      }
    },

    // 原创认证加入成果
    addcert(index) {
      entachievementsadditem({
        achievements_id: this.id,
        origin_id: this.page2[index].id, //原创认证 专利 商标只能传一样
      }).then((res) => {
        if (res.data.code == 200) {
          window.sessionStorage.setItem("AchievementNamefujian", "third");
          this.refresh();
          this.dialogtrusteeship = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    trusteeshipcert() {
      const n = ++this.thisNumss;
      // 获取更多的原创认证
      makerindex({ page: n }).then((res) => {
        if (res.data.code == 200) {
          if (res.data.data.data.length == 0) {
            this.Projectss = false;
            this.nullNum = true;
          } else {
            this.pages = res.data.data.data;
            this.pages.forEach((i) => {
              this.page2.push(i);
            });
          }
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 原创认证模糊查询
    oninputss() {
      if (this.input3 != "") {
        makerindex({ _keywords: this.input3 }).then((res) => {
          if (res.data.code == 200) {
            this.page2 = res.data.data.data;
            this.page2.forEach((i) => {
              if (i.status == 1) {
                i.status = "未认证";
              } else if (i.status == 2) {
                i.status = "认证中";
              } else if (i.status == 3) {
                i.status = "已实名";
              } else {
                i.status = "未认证";
              }
            });
            if (res.data.data.total > 5) {
              this.Projectss = true;
            } else {
              this.Projectss = false;
            }
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        // 获取原创认证列表
        makerindex({
          page: this.thisNumss,
        }).then((res) => {
          if (res.data.code == 200) {
            this.page2 = res.data.data.data;
            this.page2.forEach((i) => {
              if (i.status == 1) {
                i.status = "未认证";
              } else if (i.status == 2) {
                i.status = "认证中";
              } else if (i.status == 3) {
                i.status = "已实名";
              } else {
                i.status = "未认证";
              }
            });
            if (res.data.data.total > 5) {
              this.Projectss = true;
            } else {
              this.Projectss = false;
            }
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },

    // 研发项目加入成果
    addsci(index) {
      entachievementsadditem({
        achievements_id: this.id,
        dev_id: this.page3[index].id, //原创认证 专利 商标只能传一样
      }).then((res) => {
        if (res.data.code == 200) {
          window.sessionStorage.setItem("AchievementNamefujian", "fourth");
          this.refresh();
          this.dialogtrusteeship = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    trusteeshipsci() {
      const n = ++this.thisNumsss;
      // 获取更多的研发项目
      researchprojects({
        page: n,
        // research_dev_title: "测试",
      }).then((res) => {
        if (res.data.code == 200) {
          if (res.data.data.data.length == 0) {
            this.Projectss = false;
            this.nullNum = true;
          } else {
            this.pages = res.data.data.data;
            this.pages.forEach((i) => {
              this.page3.push(i);
            });
          }
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 研发项目模糊查询
    oninputsss() {
      if (this.input4 != "") {
        researchprojects({ _keywords: this.input4 }).then((res) => {
          if (res.data.code == 200) {
            this.page3 = res.data.data.data;

            if (res.data.data.total > 5) {
              this.Projectsss = true;
            } else {
              this.Projectsss = false;
            }
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        // 获取原创认证列表
        researchprojects({
          page: this.thisNumsss,
        }).then((res) => {
          if (res.data.code == 200) {
            this.page3 = res.data.data.data;

            if (res.data.data.total > 5) {
              this.Projectsss = true;
            } else {
              this.Projectsss = false;
            }
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },

    // 研发产品加入成果
    addcp(index) {
      entachievementsadditem({
        achievements_id: this.id,
        product_id: this.page4[index].id, //原创认证 专利 商标只能传一样
      }).then((res) => {
        if (res.data.code == 200) {
          window.sessionStorage.setItem("AchievementNamefujian", "fifth");
          this.refresh();
          this.dialogtrusteeship = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    trusteeshipcp() {
      const n = ++this.thisNumssss;
      // 获取更多的研发产品
      entproductindex({
        page: n,
        // research_dev_title: "测试",
      }).then((res) => {
        if (res.data.code == 200) {
          if (res.data.data.data.length == 0) {
            this.Projectss = false;
            this.nullNum = true;
          } else {
            this.pages = res.data.data.data;
            this.pages.forEach((i) => {
              this.page4.push(i);
            });
          }
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 研发产品模糊查询
    oninputssss() {
      if (this.input4 != "") {
        entproductindex({ _keywords: this.input4 }).then((res) => {
          if (res.data.code == 200) {
            this.page4 = res.data.data.data;

            if (res.data.data.total > 5) {
              this.Projectsss = true;
            } else {
              this.Projectsss = false;
            }
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        // 获取原创认证列表
        entproductindex({
          page: this.thisNumssss,
        }).then((res) => {
          if (res.data.code == 200) {
            this.page4 = res.data.data.data;

            if (res.data.data.total > 5) {
              this.Projectssss = true;
            } else {
              this.Projectssss = false;
            }
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },

    // 专利授权移出成果
    removep(index) {
      this.$confirm("此操作将删除此专利附件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          entachievementsremoveitem({
            achievements_id: this.id,
            patent_id: this.patent[index].patent_id,
          }).then((res) => {
            if (res.data.code == 200) {
              window.sessionStorage.setItem("AchievementNamefujian", "first");
              this.refresh();
              this.dialogtrusteeship = false;
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    // 商标授权移出成果
    removet(index) {
      this.$confirm("此操作将删除此商标附件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          entachievementsremoveitem({
            achievements_id: this.id,
            trademark_id: this.trademark[index].trademark_id,
          }).then((res) => {
            if (res.data.code == 200) {
              window.sessionStorage.setItem("AchievementNamefujian", "second");
              this.refresh();
              this.dialogtrusteeship = false;
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    // 原创认证授权移出成果
    removeo(index) {
      this.$confirm("此操作将删除此原创认证附件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          entachievementsremoveitem({
            achievements_id: this.id,
            origin_id: this.origin[index].origin_id,
          }).then((res) => {
            if (res.data.code == 200) {
              window.sessionStorage.setItem("AchievementNamefujian", "third");
              this.refresh();
              this.dialogtrusteeship = false;
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 研发项目移出成果
    removesci(index) {
      this.$confirm("此操作将删除此原创认证附件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          entachievementsremoveitem({
            achievements_id: this.id,
            dev_id: this.scipro[index].dev_id,
          }).then((res) => {
            if (res.data.code == 200) {
              window.sessionStorage.setItem("AchievementNamefujian", "fourth");
              this.refresh();
              this.dialogtrusteeship = false;
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 研发产品移出成果
    removecp(index) {
      this.$confirm("此操作将删除此原创认证附件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          entachievementsremoveitem({
            achievements_id: this.id,
            product_id: this.product[index].product_id,
          }).then((res) => {
            if (res.data.code == 200) {
              window.sessionStorage.setItem("AchievementNamefujian", "fifth");
              this.refresh();
              this.dialogtrusteeship = false;
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    refresh() {
      // this.$loading.show(); // 显示loading
      //    获取详情
      entachievementsdetail({ id: this.id }).then((res) => {
        if (res.data.code == 200) {
          this.title = res.data.data.title;
          this.pro = res.data.data.pro;
          this.amount = res.data.data.amount;
          this.remark = res.data.data.remark;
          this.patent = res.data.data.patent;
          this.trademark = res.data.data.trademark;
          this.origin = res.data.data.origin;
          this.scipro = res.data.data.dev;
          this.product = res.data.data.product;
          this.sell = res.data.data.sell;
          this.valuation = res.data.data.valuation;
          this.maturity = res.data.data.maturity;
          this.ipc = res.data.data.ipc;
          this.ent_id = res.data.data.ent_id;
          if (this.patent.length == 0) {
            this.havepatent = false;
            this.nullpatent = true;
          } else {
            this.havepatent = true;
            this.nullpatent = false;
          }
          if (this.trademark.length == 0) {
            this.havetrademark = false;
            this.nulltrademark = true;
          } else {
            this.havetrademark = true;
            this.nulltrademark = false;
          }
          if (this.origin.length == 0) {
            this.haveorigin = false;
            this.nullorigin = true;
          } else {
            this.haveorigin = true;
            this.nullorigin = false;
          }
          if (this.scipro.length == 0) {
            this.havescipro = false;
            this.nullscipro = true;
          } else {
            this.havescipro = true;
            this.nullscipro = false;
          }
          if (this.product.length == 0) {
            this.havecp = false;
            this.nullcp = true;
          } else {
            this.havecp = true;
            this.nullcp = false;
          }
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },

  created() {
    this.id = window.sessionStorage.getItem("Achievementnum");
    this.activeName = window.sessionStorage.getItem("AchievementNamefujian");
    this.companyentid = window.sessionStorage.getItem("companyentid");
    //    获取详情
    entachievementsdetail({ id: this.id }).then((res) => {
      if (res.data.code == 200) {
        this.title = res.data.data.title;
        this.pro = res.data.data.pro;
        this.amount = res.data.data.amount;
        this.remark = res.data.data.remark;
        this.patent = res.data.data.patent;
        this.trademark = res.data.data.trademark;
        this.origin = res.data.data.origin;
        this.scipro = res.data.data.dev;
        this.product = res.data.data.product;
        this.sell = res.data.data.sell;
        this.valuation = res.data.data.valuation;
        this.maturity = res.data.data.maturity;
        this.ipc = res.data.data.ipc;
        this.ent_id = res.data.data.ent_id;
        if (this.patent.length == 0) {
          this.havepatent = false;
          this.nullpatent = true;
        } else {
          this.havepatent = true;
          this.nullpatent = false;
        }
        if (this.trademark.length == 0) {
          this.havetrademark = false;
          this.nulltrademark = true;
        } else {
          this.havetrademark = true;
          this.nulltrademark = false;
        }
        if (this.origin.length == 0) {
          this.haveorigin = false;
          this.nullorigin = true;
        } else {
          this.haveorigin = true;
          this.nullorigin = false;
        }
        if (this.scipro.length == 0) {
          this.havescipro = false;
          this.nullscipro = true;
        } else {
          this.havescipro = true;
          this.nullscipro = false;
        }
        if (this.product.length == 0) {
          this.havecp = false;
          this.nullcp = true;
        } else {
          this.havecp = true;
          this.nullcp = false;
        }
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    // 获取企业专利
    patenttrusteeshipentpatent({ page: this.thisNum }).then((res) => {
      if (res.data.code == 200) {
        this.page = res.data.data.data;
        this.page.forEach((i) => {
          if (i.warnDate == null) {
            i.warnDate = "";
          }
        });
        if (res.data.data.total > 5) {
          this.Project = true;
        } else {
          this.Project = false;
        }
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    // 获取商标
    Obtaintrademark({ page: this.thisNums }).then((res) => {
      if (res.data.code == 200) {
        this.page1 = res.data.data.data;
        if (res.data.data.total > 5) {
          this.Projects = true;
        } else {
          this.Projects = false;
        }
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
      this.$loading.hide(); // 隐藏loading
    });
    // 获取原创认证列表
    makerindex({
      page: this.thisNumss,
    }).then((res) => {
      if (res.data.code == 200) {
        this.page2 = res.data.data.data;
        this.page2.forEach((i) => {
          if (i.status == 1) {
            i.status = "未认证";
          } else if (i.status == 2) {
            i.status = "认证中";
          } else if (i.status == 3) {
            i.status = "已实名";
          } else {
            i.status = "未认证";
          }
        });
        if (res.data.data.total > 5) {
          this.Projectss = true;
        } else {
          this.Projectss = false;
        }
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });

    // 获取产品列表
    entproductindex({
      page: this.thisNumssss,
      limit: 20,
    }).then((res) => {
      if (res.data.code == 200) {
        this.page4 = res.data.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    // 获取研发项目
    researchprojects({
      page: this.thisNumsss,
      // research_dev_title: "测试",
    }).then((res) => {
      if (res.data.code == 200) {
        this.page3 = res.data.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
  mounted() {
    BUS.$on("Achievementnum", (data) => {
      this.id = data;
      //    获取详情
      entachievementsdetail({ id: data }).then((res) => {
        if (res.data.code == 200) {
          this.title = res.data.data.title;
          this.pro = res.data.data.pro;
          this.amount = res.data.data.amount;
          this.remark = res.data.data.remark;
          this.patent = res.data.data.patent;
          this.trademark = res.data.data.trademark;
          this.origin = res.data.data.origin;
          this.scipro = res.data.data.dev;
          this.product = res.data.data.product;
          this.sell = res.data.data.sell;
          this.valuation = res.data.data.valuation;
          this.maturity = res.data.data.maturity;
          this.ipc = res.data.data.ipc;
          this.ent_id = res.data.data.ent_id;
          if (this.patent.length == 0) {
            this.havepatent = false;
            this.nullpatent = true;
          } else {
            this.havepatent = true;
            this.nullpatent = false;
          }
          if (this.trademark.length == 0) {
            this.havetrademark = false;
            this.nulltrademark = true;
          } else {
            this.havetrademark = true;
            this.nulltrademark = false;
          }
          if (this.origin.length == 0) {
            this.haveorigin = false;
            this.nullorigin = true;
          } else {
            this.haveorigin = true;
            this.nullorigin = false;
          }
          if (this.scipro.length == 0) {
            this.havescipro = false;
            this.nullscipro = true;
          } else {
            this.havescipro = true;
            this.nullscipro = false;
          }
          if (this.product.length == 0) {
            this.havecp = false;
            this.nullcp = true;
          } else {
            this.havecp = true;
            this.nullcp = false;
          }
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    });
  },
};
</script>
      
<style scoped>
.tabscard >>> .el-tabs__header.is-left {
  width: 20% !important;
  margin-right: 20px !important;
  float: left;
  margin-bottom: 0;
  margin-right: 10px;
}
.tabscard >>> .el-tabs__nav {
  border-radius: 4px 0 0 4px;
  /* border-bottom: 1px solid #E4E7ED; */
  border-right: none !important;
  border-left: none !important;
}
.tabscard >>> .el-tabs__item.is-left:first-child {
  border-right: none;
  border-top: none;
}
.tabscard >>> .el-tabs__item.is-left {
  border: none;
  border-top: 1px solid #e4e7ed;
  text-align: left;
}
.tabscard >>> .el-tabs__nav-scroll {
  height: 552px !important;
  border: 1px solid #e5e5e5;
  border-bottom: none;
  border-top: none;
  overflow: hidden;
}
.checkboxgroup >>> .el-checkbox__label {
  width: 90%;
  line-height: 0px;
  padding: 5px 10px;
}
.checkboxgroup:hover {
  background: #f4fbfc;
}
.itembor {
  width: 6px;
  height: 6px;
  background: #e7e9ef;
  border-radius: 50%;
  position: relative;
  top: 6px;
  left: -10px;
}
.Patent-abstract {
  border-left: 4px solid #52c5cb;
  height: 20px;
  line-height: 20px;
}
table {
  border-collapse: collapse;
}
tr {
  width: 100%;
}
td {
  border: 1px solid #f0f0f0;
}
.tdtit {
  width: 15%;
  height: 40px;
  line-height: 40px;
  background: #f1f3f9;
  border: 1px solid rgba(233, 233, 233, 1);
  padding-left: 10px;
  font-size: 14px;
  color: #6a7589;
}
.tdcont {
  width: 35%;
  padding-left: 10px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #353a44;
}
/* .tdcontss {
  width: 15%;
  padding-left: 10px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #353a44;
  border: 1px solid rgba(233, 233, 233, 1);
  border-top: none;
} */
.tdconts {
  width: 85%;
  padding: 10px;
  height: 40px;
  line-height: 30px;
  font-size: 14px;
  color: #353a44;
}
.tdcontss {
  width: 85%;
  padding: 10px;
  height: 40px;
  line-height: 30px;
  font-size: 14px;
  color: #353a44;
}
.dialogcont {
  font-size: 14px;
  line-height: 30px;
  padding: 20px 20px 0 20px;
}
.dialogitem {
  padding: 5px 0 5px 0;
  border-bottom: 1px solid #fbfbfb;
  color: #7a7a7a;
  overflow-y: scroll;
  height: 500px;
}
.overflow {
  margin: 10px 0 0 0;
}
.grow3 {
  line-height: 30px;
  width: 30%;
}
.grow7 {
  width: 70%;
}

.dialogel >>> .el-input__inner {
  border: 1px solid #fff;
}
.textarea >>> .el-textarea__inner {
  border: 1px solid #fff;
}
.dialogel {
  padding: 0 10px 0 0;
  text-align: right;
}
.dialogbut {
  padding: 6px 15px;
  margin: 0 10px 10px 0;
}
.title {
  font-size: 14px;
  text-align: center;
  margin: 10px 0 10px 0;
}
.achieBox {
  width: 100%;
  margin: 10px auto 0;
  position: relative;
}
.iconfont {
  font-size: 14px;
  padding: 0 2px 0 0;
}
.addachie {
  text-align: center;
  position: absolute;
  top: 20px;
  right: 30px;
}
.main-items {
  width: 99%;
  min-height: 200px;
  border: 1px solid #efefef;
}
.nullachi {
  text-align: center;
  font-size: 14px;
  color: #e5e5e5;
  line-height: 25px;
  padding: 10px 0 0 0;
}
.itemcont {
  width: 96%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #353a44;
  padding: 13px 0 13px 0;
}

.but-box {
  width: 96%;
  margin: 20px auto 0;
}
.buttonsure {
  width: 80px;
  line-height: 30px;
  font-size: 14px;
  color: white;
  background: #409eff;
  border: none;
  border-radius: 5px;
  margin: 10px 10px 0 0;
}

.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>
      